<template>
    <div>    	
        <b-modal id="bv-modal-view-trustee-history" size="xxl" hide-footer title="Membership History">
            <bot-member-history :employee_id="selectedEmployeeId" :pf="pf"></bot-member-history>
        </b-modal>

        <b-modal size="lg" hide-footer id="bv-trustee-user-update" :title="modalTitle">
            <bot-add-update-user-modal :status="status" :pf="pf" :employee_id="selectedEmployeeId" :name="selectedName" :mode="mode" :data_id="selectedId" @hideModal="hideModal"></bot-add-update-user-modal>
        </b-modal>

      <b-modal size="lg" hide-footer id="bv-trustee-user-add" title="Open Membership">
        <bot-add-update-user-modal :status="1" :pf="pf" :name="''" mode="add" @hideModal="hideModal"></bot-add-update-user-modal>
      </b-modal>

        <b-modal size="md" hide-footer id="bv-delete-confirm-modal" title="Are you sure?" ok-variant="danger" cancel-variant="secondary">
            <b-form @submit.stop.prevent="removeUser">
                <b-input-group class="mb-2">
                    <b-form-input autocomplete="off" type="password" placeholder="Password" class="radius-8" name="password" v-model="deleteData.password" v-validate="{required: true, min:8}" :state="validateState('password')" aria-describedby="password-feedback"></b-form-input>
                    <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                </b-input-group>
                <div class="d-flex justify-content-center align-items-center">
                    <b-button type="submit" variant="primary" id="delete-btn" class=" mr-2 px-4">Remove</b-button>
                    <b-button type="button" variant="secondary" id="delete-btn" class=" ml-2 px-4" @click="$bvModal.hide('bv-delete-confirm-modal')">Cancel</b-button>
                </div>
            </b-form>
        </b-modal>

        <b-sidebar id="sidebar_right" title="Filter" right shadow>
            <div class="px-3 py-2 filter-wrapper">
                <div>
                    <label>Name</label>
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Name" name="name" v-model="filter.name" ></b-form-input>
                    </b-input-group>
                </div>
                <div>
                    <label>Employee Code</label>
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Employee Code" name="employee_code" v-model="filter.employee_code" ></b-form-input>
                    </b-input-group>
                </div>
                <div>
                    <label>Role</label>
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select name="role" class='form-control' v-model="filter.role_id">
                            <option value=''>Select Role</option>
                            <option v-for='data in roles' :value='data.value' :key="data.value+data.text">{{ data.text }}</option>
                        </select>
                    </b-input-group>
                </div>
                <div>
                    <label>Representative</label>
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select name="representative" class='form-control' v-model="filter.representative_id">
                            <option value='' >Select Representative</option>
                            <option v-for='data in representatives' :value="data.value" :key="data.value+data.text">{{ data.text }}</option>
                        </select>
                    </b-input-group>
                </div>
                            
                <div class="mt-4 row" >
                    <div class="col-6">
                        <b-button class="filter_btn" v-b-toggle.sidebar_right variant="primary" block title="Set Filter"><div>Set Filter</div></b-button>
                    </div>
                    <div class="col-6">
                        <b-button class="filter_btn" variant="primary" block  title="Clear Filter" @click="resetFilter();"><div>Clear Filter</div></b-button>
                    </div>                                        
                </div>
            </div>
        </b-sidebar>

        <b-overlay :show="loading">
            <div class="clearfix row py-2 mb-2">
                <div class="col-sm-4">
                    <div class="custom-search w-100">
                        <b-input-group class="mb-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <div class="col-sm-8 float-right text-right">
                    <template  v-if="$acl['bot/'+types[pf]] == 2"><b-button v-if="status == 1" id="show-btn" class="mr-3" @click="addTrustee">+ Add Member</b-button></template>
                    <b-button id="show-btn" class="mr-3" @click="exportTrusteeList"><b-icon class="mr-2" icon="cloud-download-fill"></b-icon>Download List</b-button>
                    <b-button id="show-btn" class="custom-wizard-btn" v-b-toggle.sidebar_right><b-icon class="mr-2" icon="funnel-fill"></b-icon>Filter</b-button>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <double-scroll-wrapper> <!-- Rejwan: 01-12-2025 Double Scroll Wrapper -->
                    <div class="employee-table-wrapper" >
                        
                        <table id="bot-members-table" class="employee-list-table dataTable table-overflow table-sticky table data-table">

                        <thead>
                            <tr class="table-head">
                                <td class="checkbox-col">
                                    <input type="checkbox" v-model="selectAll" class=""/>
                                    <label></label>
                                </td>
                                <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(member , n) in paginatedData" :key="member.id">
                                <td class="checkbox-col">
                                    <input type="checkbox" class="justify-content-center " v-model="selected" :value="member.id" number/>
                                    <label></label>
                                </td>
                                <td class="align-middle ">{{member.name}}</td>
                                <td class="align-middle">{{member.employee_code}}</td>
                                <td class="align-middle">{{member.role}}</td>
                                <td class="align-middle">{{member.representative}}</td>
                                <td class="align-middle">{{member.role_start_date}}</td>
                                <td class="align-middle">{{member.role_end_date}}</td>
                                <td class="align-middle">{{member.tenure}}</td>
                                <td class="align-middle leave-reason-wrapper">{{member.remarks}}</td>

                                <td class="clearfix pr-2">
                                    <div class="float-right position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                <b-button-group class="mr-0">
                                                    <b-button class="text-left rounded edit-btn" title="View History" @click="viewHistory(member.employee_id)">
                                                        <b-icon icon="clock-history" class="mr-2" aria-hidden="true" ></b-icon>View History
                                                    </b-button>
                                                    <template  v-if="$acl['bot/'+types[pf]] == 2">
                                                        <b-button class="text-left rounded edit-btn" title="Update" @click="editTrustee(member.id, member.employee_id, member.name, 'edit', 'Update membership')">
                                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Update
                                                        </b-button>
                                                        <b-button v-if="status == 1" class="text-left rounded delete-btn" title="End Membership" @click="editTrustee(member.id, member.employee_id, member.name, 'end', 'End Membership')">
                                                            <b-icon icon="journal-x" class="mr-2" aria-hidden="true"></b-icon>End Membership
                                                        </b-button>
                                                        <b-button v-else class="text-left rounded delete-btn" title="Open Membership" @click="editTrustee(member.id, member.employee_id, member.name, 'reopen', 'Open Membership')">
                                                            <b-icon icon="journal-x" class="mr-2" aria-hidden="true"></b-icon>Open Membership
                                                        </b-button>
                                                    </template>
                                                    <b-button v-if="member.attachment" class="text-left rounded delete-btn" title="Download Attachment(s)" @click="downloadAttachment(member.id, member.employee_id)">
                                                        <b-icon icon="cloud-download" class="mr-2" aria-hidden="true"></b-icon>Download Attachment(s)
                                                    </b-button>
                                                    <template  v-if="$acl['bot/'+types[pf]] == 2">
                                                        <b-button v-if="status == 1" class="text-left rounded delete-btn" title="Remove" @click="deleteUserDialog(member.employee_id)">
                                                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Remove
                                                        </b-button>
                                                    </template>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                    <div v-else class="px-3 mt-4">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select :options="length_options" v-model="temp_length" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{paginatedData.length}} records found.</li>
                        </ul>
                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                    </div>
                        
                    </div>
                                        
                    </double-scroll-wrapper> <!-- Rejwan: 01-12-2025 Double Scroll Wrapper -->
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    //import AddUpdateUserModal from "./AddUpdateUserModal.vue";
    //import MemberHistory from "./MemberHistory.vue";

    export default {
        mounted() {
            //this.permission = this.$acl['Role/details'];

            const tableWrapper = this.$el.querySelector('.employee-table-wrapper');
            if (!tableWrapper) return;

            const observer = new MutationObserver(() => {
                const anyOpen = tableWrapper.querySelector('.dropdown-menu.show');
                tableWrapper.classList.toggle('dropdown-open', !!anyOpen);
            });

            observer.observe(tableWrapper, { subtree: true, attributes: true, attributeFilter: ['class'] });
        },
        name: 'members',
        //components: {MemberHistory, AddUpdateUserModal},
        props:['status', 'pf'],
        data(){

            let sortOrders = {};
            let columns = [
                {label: 'Name', name: 'name' },
                {label: 'Employee Code', name: 'employee_code'},
                {label: 'Role in Trustee Board', name: 'role'},
                {label: 'Representative', name: 'representative'},
                {label: 'Role Start Date', name: 'role_start_date'},
                {label: 'Role End Date', name: 'role_end_date'},
                {label: 'Bot Membership Tenure', name: 'tenure'},
                {label: 'Remarks', name: 'remarks'},
            ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
            return {
                types:{0:'gf' , 1:'pf', 2:'wf'},
                permission: '',
                filter:{
                    name: '',
                    employee_id: '',
                    role_id: '',
                    representative_id: '',
                },
                columns:columns,
                sortOrders:sortOrders,
                sortKey: 'name',
                trustees: [],
                selected:[],
                deleteData: {
                    employee_id:0,
                    password:'',
                },
                selectedEmployeeId:0,
                selectedName:'',
                selectedId: 0,
                pagination: {currentPage: 1, pages:1},
                search: '',
                roles:[],
                mode: '',
                modalTitle: '',
                representatives:[],
                temp_length: 20,
                length_options: [
                        { value: 20, text: "20" },
                        { value: 50, text: "50" },
                        { value: 100, text: "100" }
                    ],
                loading: false,
            }
        },
        methods:{
            resetFilter(){
                this.filter = {
                    name: '',
                    employee_id: '',
                    role_id: '',
                    representative_id: '',
                };
            },
            sortBy(key) {
                this.resetPagination();
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;

                const order = this.sortOrders[key];

                this.paginatedData.sort((a, b) => {
                    const result = String(a[key]).localeCompare(String(b[key]));
                    return order == 1 ? result : -result;
                });
            },
          addTrustee(){
              this.$bvModal.show('bv-trustee-user-add');
          },
            viewHistory(employee_id){
                this.selectedEmployeeId = employee_id;
                this.$bvModal.show('bv-modal-view-trustee-history');
            },
            editTrustee(id, employee_id, name, mode, title){
                this.selectedEmployeeId = employee_id;
                this.selectedName = name;
                this.selectedId = id;
                this.mode = mode;
                this.modalTitle = title;

                this.$bvModal.show('bv-trustee-user-update')
            },
            hideModal(){
              this.$bvModal.hide('bv-trustee-user-update')
              this.$bvModal.hide('bv-trustee-user-add')
              this.gettrusteeData();
            },
            getRoles(){
                axios.get(this.$api_url + '/bot/role/list',{
                    params: {
                        type: 'list',
                      pf:this.pf
                    }
                }).then(response => {
                    this.roles = response.data;
                }).catch(error => this.serverError(error));
            },

            deleteUserDialog(employee_id){
                this.deleteData.employee_id = employee_id;
                this.$bvModal.show('bv-delete-confirm-modal')
            },

            removeUser(){
              this.$validator.validateAll().then(valid => {
                    if (valid) {
                      let formData = new FormData()
                      formData.append('employee_id', this.deleteData.employee_id)
                      formData.append('password', this.deleteData.password)
                      this.loading = true;
                      axios.post(this.$api_url + '/bot/user/delete?pf='+this.pf, formData).then(response => {
                        this.gettrusteeData();
                        this.$bvModal.hide('bv-delete-confirm-modal')
                        this.$bvToast.toast(response.data.message,{
                          variant: response.data.variant,
                          title: response.data.title,
                          solid: true,
                        })
                        this.loading = false;
                      }).catch(error => this.serverError(error));
                    }
              });




            },
            downloadAttachment(id, employee_id) {
                let formData = new FormData();
                formData.append('id', id);
                this.loading = true;
                axios.post(this.$api_url + '/bot/attachment/download?pf='+this.pf, formData, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        const downloadLink = document.createElement('a');
                        downloadLink.href = URL.createObjectURL(blob);
                        downloadLink.download = employee_id + '_attachments.zip';
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                        this.loading = false;
                    })
                    .catch(error => {
                        this.$bvToast.toast("Download failed.", { title: 'Error', variant: 'danger', solid: true });
                        this.loading = false;
                    });
            },

            getRepresentatives(){
                axios.get(this.$api_url + '/bot/role/representatives',{
                    params: {
                        type: 'list',
                      pf:this.pf
                    }
                }).then(response => {
                    this.representatives = response.data;
                }).catch(error => this.serverError(error));
            },
            gettrusteeData(){
                this.loading = true;
                axios.get(this.$api_url + '/bot/trustee/list',{
                    params:{
                        status: this.status,
                        pf:this.pf
                    }
                }).then(response => {
                    this.trustees = response.data;
                    this.loading = false;
                }).catch(error => this.serverError(error));
            },
            exportTrusteeList: function () {
                if(this.paginatedData.length == 0){
                    this.$bvToast.toast('No member record present to download.',{
                        variant: 'warning',
                        title: 'Warning!',
                        solid: true,
                    })
                    return;
                }
                let selectedTrustee = this.selected;
                if(selectedTrustee.length == 0){
                  this.$bvToast.toast('No member record selected to download.',{
                    variant: 'warning',
                    title: 'Warning!',
                    solid: true,
                  })
                  return;
                }

                this.loading = true

                const formData = new FormData();

                const config = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    responseType: 'blob'
                };
                formData.append('data', JSON.stringify(selectedTrustee))

                axios.post(this.$api_url + '/bot/trustee/download?pf='+this.pf , formData, config)
                    .then((response) => {
                        this.$bvToast.toast(response.data.message, { title: 'Success!', variant: 'success', solid: true, toaster: "toaster: b-toaster-top-right" });

                        const blob = new Blob([response.data], {
                            type: 'application/vnd.ms-excel'
                        });

                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.setAttribute('download', this.status == 1 ? 'BoT Active Members.xlsx' : 'BoT Inactive Members.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        this.loading = false
                    })
                    .catch((error) => {
                        this.loading = false
                        console.error("Download error:", error);
                        this.serverError(error)
                        this.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                    });

            },
        },
        created() {
          this.gettrusteeData();
          this.getRoles();
          this.getRepresentatives();
        },
        computed: {
            selectAll: {
                get: function () {
                    if(this.paginatedData.length == 0) return false;
                    return this.paginatedData ? this.selected.length == this.paginatedData.length : false;
                },
                set: function (value) {
                    if (value) {
                        this.selected = this.paginatedData.map(el => el.id)
                    } else {
                        this.selected =[]
                    }
                }
            },

            filteredData() {
                let filtered_list = Array.isArray(this.trustees) ? this.trustees : [];
                
                if (this.search) {
                    const searchLower = this.search.toLowerCase();
                    filtered_list = filtered_list.filter(row =>
                        Object.values(row).some(value =>
                            String(value).toLowerCase().includes(searchLower)
                        )
                    );
                }
                filtered_list = filtered_list.filter(row => {
                    let ret = true;
                    for(const [key, value] of Object.entries(this.filter)){
                        if(String(value) != ''){
                            ret = ret && String(row[key]).toLowerCase().includes(String(value).toLowerCase());
                        }
                    }
                    return ret;
                });

                return filtered_list;
            },           

            paginatedData() {
                return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
            }
        }
    }
</script>

<style scoped>
#bot-members-table .custom-control-input{
  left:unset !important;
}
.employee-tab .btn.btn-primary.btn-block.not-collapsed {
  text-align: center;
  border-color: #004242 !important;
  background-color: #004242 !important;
}
.employee-tab .btn.btn-primary.btn-block.not-collapsed:hover {
    background-color: #DDF5F9 !important;
    border-color: #0892A4 !important;
    color: #004242 !important;
}
</style>
